<custom-view *ngIf="isCustom" [component]="customComponent" [customDataBinding]="customData">
</custom-view>

<common-chart *ngIf="!isCustom" [chartCriteria]="chartCriteria">
</common-chart>
